// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__fZ6rT","resendInfoText":"OnGoingPaymentBox_resendInfoText__2_GO8"};